import React from 'react';
import './tabla.css';

function getClassString(classNumber) {
  switch (classNumber) {
    case 0:
    case 1:
    case 2:
      return 'sm.png';
    case 16:
    case 17:
    case 18:
      return 'bk.png';
    case 32:
    case 33:
    case 34:
      return 'me.png';
    case 48:
    case 50:
      return 'mg.png';
    case 64:
    case 66:
      return 'dl.png';
    default:
      return 'Desconocido';
  }
}

function getPkLevelString(pkLevel) {
  switch (pkLevel) {
    case 1:
    case 2:
      return 'Hero';
    case 3:
      return 'Commoner';
    case 4:
      return 'Murderer';
    case 5:
      return 'Phonomania';
    default:
      return 'Desconocido';
  }
}

function getPkLevelColor(pkLevel) {
  switch (pkLevel) {
    case 1:
      return '#6478ff';
    case 2:
      return '#8cb4ff';
    case 3:
      return '#c8dcff';
    case 4:
      return '#ff963c';
    case 5:
      return '#ff501e';
    default:
      return '#ffffff';
  }
}

function TablaPK({ jugadores }) {
  const maxOrden = Math.max(...jugadores.map(jugador => jugador.Orden), 0);
  const nuevoOrden = maxOrden + 1;

  return (
    <table className='table'>
      <thead>
        <tr>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>#</th>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>Personaje</th>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>Puntos PK</th>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>Muertes</th>
          <th style={{ color: 'grey', textAlign: 'left', textTransform: 'uppercase' }}>Acumuladas</th>
        </tr>
      </thead>
      <tbody>
        {jugadores.map((jugador) => (
          <tr key={jugador.Orden}>
            <td data-label="#" style={{ color: 'white' }}>{jugador.Orden}</td>
            <td data-label="Personaje" style={{ color: 'white' }}>
              <div className={jugador.ConnectStat === 1 ? 'connected' : 'disconnected'}>
                <div className="player-container">
                  <img src={`assets/img/${getClassString(jugador.Class)}`} width="30" alt="" title={jugador.ConnectStat === 1 ? 'Conectado' : 'Desconectado'} style={{ marginRight: '8px' }} />
                  <span>{jugador.Name} <span style={{ backgroundColor: getPkLevelColor(jugador.PkLevel), color: 'white', padding: '2px 5px', borderRadius: '3px', fontSize: '10px', color: '#080808' }}>{getPkLevelString(jugador.PkLevel)}</span></span>
                </div>
              </div>
            </td>
            <td data-label="Puntos PK" style={{ color: 'white' }}>{jugador.PkPoints_EXT}</td>
            <td data-label="Muertes" style={{ color: 'white' }}>{jugador.PkCount}</td>
            <td data-label="Acumuladas" style={{ color: 'white' }}>{jugador.Kills}</td>
          </tr>
        ))}
        <tr>
          <td style={{ color: 'white' }}>{nuevoOrden}</td>
          <td colSpan="4" style={{ textAlign: 'center', color: 'white' }}>¡¡PODRÍAS SER VOS!!</td>
        </tr>
      </tbody>
    </table>
  );
}

export default TablaPK;
